export default __webpack_public_path__ + "static/media/SheetMetalImg5.8e6085e0.jpg";